export default {
  default: {
    navColor: '#ffff',
    main: '',
    complimentary: '',
    accent: '',
  },
  // TODO: more themes
};
